module.exports = __webpack_public_path__ + "static/media/he-IL.78de33e1.md";